import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_42bfa9c9: FaireBrandEntity = {
  token: "b_42bfa9c9",
  type: "brand",
  name: "Ten Thousand Villages",
  avatarUrl:
    "https://cdn.faire.com/fastly/a7e00c630987227a6d038639f761c07b2fef3a10362e37bd043e46f248307264.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/a7e00c630987227a6d038639f761c07b2fef3a10362e37bd043e46f248307264.jpeg",
  minimumOrderDollars: 150,
  rating: 5.0,
  reviewCount: 1178,
  isTopShop: true,
  meta: {
    source: "api",
    importedAt: "2026-04-06T00:00:00.000Z",
    importedBy: "entity-db-cli",
  },
};
